import { render, staticRenderFns } from "./FormScriptButton.vue?vue&type=template&id=3b4aed94&"
import script from "./FormScriptButton.vue?vue&type=script&lang=ts&"
export * from "./FormScriptButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports